import { RegisterComponent, Scene3D } from 'feng3d-three';
import { RoomEnvironment } from '../thirdparty/three/imports';

declare module 'feng3d-three'
{
    interface ComponentMap { RoomEnvironment3D: RoomEnvironment3D; }
}

/**
 * 3D场景，包装`three`中`Scene`
 */
@RegisterComponent({ name: 'RoomEnvironment3D' })
export class RoomEnvironment3D extends Scene3D
{
    declare _scene: RoomEnvironment;

    init()
    {
        this._scene = new RoomEnvironment();

        super.init();
    }
}
